import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import SeleccionarFechas from './SeleccionarFechas';
import Pago from './Pago/Pago'
import GraciasPorSuCompra from './GraciasPorSuCompra';
import { useDispatch, useSelector } from 'react-redux';
import { fetchObra, selector } from '../../redux/slices/ObrasSlice'
import { useAuthState } from '../../context'

export function ComprarEntradas() {

    const queryString = window.location.search;

    const { id, date, mode } = useParams();
    const { obra } = useSelector(selector);

    const { user } = useAuthState();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [detallesCompra, setDetallesCompra] = useState({
        fechaObra: date,
        idObra: id,
        email: user?.email,
        name: user?.name,
        phone: user?.phone,
        titulo: obra?.titulo,
        cantidad: 1,
    });

    useEffect(() => {
        if (!obra?.titulo) dispatch(fetchObra(id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    // C2: sólo actualizamos el titulo cuando aún no se ha fijado.
    useEffect(() => {
        if (obra?.titulo && !detallesCompra.titulo) {
            setDetallesCompra((prev) => ({ ...prev, titulo: obra.titulo }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [obra?.titulo])

    // C4: si la sesión carga después del primer render, propagamos email/name/phone.
    useEffect(() => {
        if (user?.email && !detallesCompra.email) {
            setDetallesCompra((prev) => ({
                ...prev,
                email: user.email,
                name: user.name,
                phone: user.phone,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.email])

    useEffect(() => {
        localStorage.setItem("detallesCompra", JSON.stringify(detallesCompra));
      }, [detallesCompra]);

    useEffect(() => {
        const params = new URLSearchParams(queryString);
        const status = params.get('redirect_status');
        if (status === 'succeeded' || status === 'processing') {
            navigate(`/sala/programacion/${id}/${date}/comprar-entradas/gracias${queryString}`);
        }
        // 'failed' / 'requires_payment_method' / 'requires_action' → permanecen en /pago
        // y CheckoutForm muestra el mensaje correspondiente vía retrievePaymentIntent.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryString]);

    function CustomComponent() {
        switch (mode) {
            case "gracias":
                return <GraciasPorSuCompra queryString={queryString} detallesCompra={detallesCompra} />
            case "pago":
                return <Pago detallesCompra={detallesCompra} />
            case "ok":
                return <SeleccionarFechas
                    setDetallesCompra={setDetallesCompra}
                    detallesCompra={detallesCompra} />
            default:
                return (
                    <div>
                        <p>Página no encontrada.</p>
                        <button type="button" onClick={() => navigate("/sala/programacion")}>Volver a programación</button>
                    </div>
                );
        }
    }

    return (
        <ComprarEntradasStyled>
            <CustomComponent />
        </ComprarEntradasStyled>
    )

}



const ComprarEntradasStyled = styled.div`
width: 90%;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
font-family: Neuropol;
white-space: nowrap;
margin-top: 3vw;
color: #f46d2b;

p{
    font-family: 'Roboto', sans-serif;
}

label{
    font-family: 'Roboto', sans-serif;
    font-size: 2vw;
}

select{
    font-size: 1.5vw;
    color: #f46d2b;
    border: none;
    background: none;
    :hover{
        cursor:pointer;
    }
}

h3, p{
    color: black;
}
label{
    color: black;
}
pre{
    color: red;
    font-size: 3vw;
}
a, i{
    color: black;
    padding: 1vw;
    :hover{
        color:white;
        background-color: #f46d2b;
        cursor: pointer;
    }
}
}
button{
    margin: 2vw;
    padding: 2vw;
    font-family: Neuropol;
    font-size: 1vw;
    color: black;
    background: none;
    border: 0.2vw solid #f46d2b;
    border-radius: 2vw;
    :hover{
        background: #f46d2b;
        border: 0.2vw solid black;
        color: white;
        cursor: pointer;
    }
}
`